import React from "react";
import { ListView as KendoListView} from '@progress/kendo-react-listview'
export const ListView = (props) => {

    // todo, figure out fallback for no items.
    return (
        <KendoListView
            data={props.data}
            item={props.item}
            style={{width: "100%"}}
        />
    )
}